import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-4 py-4" data-id="element-73" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3 rounded-xl border border-brand-line bg-brand-light p-3.5 shadow-sm" data-id="element-74" data-mp="1o33s8bhenif4">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-75" data-mp="1x4bsgz3hetbu" />
        <div data-id="element-76" data-mp="1x2ikngh4u329">
          <h2 className="mb-0.5 font-display text-xl uppercase leading-none tracking-wide sm:text-3xl" data-id="element-77" data-mp="19eqyzm9pcdob">
            Your Purchase Is 100% Protected
          </h2>
          <p className="text-xs font-medium leading-snug text-brand-muted sm:text-base" data-id="element-78" data-mp="14hhb4b1yoa2l">
            You have 14 full days to explore VOLLEYBALL COACH PRO™, review the modules, use the
            practice plans, drills, templates, coaching tools, and bonus resources, and start
            applying the system with your team. If during that period you decide VOLLEYBALL COACH
            PRO™ isn’t right for you, contact us within the first 14 days and you’ll receive a full
            refund of your purchase. Zero risk.
          </p>
        </div>
      </div>
    </section>;
}